import React, { useEffect, useState } from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import CustomButton from "../../components/CustomButton";
import moment from "moment";
import DatePicker from "../../components/FormFields/DatePicker";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import DetailsCard from "../../components/DetailsCard";
import SelectInput from "../../components/FormFields/SelectInput";
import { downloadReports } from "../../../srcWeb/utils/helpers";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { useAuth } from "../../contexts/AuthContext";

const AdminRequests = () => {
  const isMobileSmall = useMediaQuery({ query: "(max-width: 344px)" });
  const { data = [], apiCall } = useApi();
  const [selectedRadio, setSelectedRadio] = useState({ key: "All Request", value: "ALL_REQUEST" });
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const navigate = useNavigate();

  const onChangeRadio = (val) => {
    setSelectedRadio(val);
    RaiseArequestTableDataApi(startDate, endDate, val.value);
  };

  const onChangeDate = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const {
    selectedStores,
    user: { userLabel = "" },

  } = useAuth();
  const { storeCode = ""} = selectedStores?.storeDetails || {}


  const isStoreActive = userLabel == "Store";
  useEffect(() => {
    // if (isStoreActive) {
      RaiseArequestTableDataApi(startDate, endDate, selectedRadio.value);
    // } else {
    //   if (storeCode.length > 0 && storeCode.length !== 0) {
    //     RaiseArequestTableDataApi(startDate, endDate, selectedRadio.value);
    //   }
    // }
  }, [selectedStores, startDate, endDate]);

  const RaiseArequestTableDataApi = (start, end, status) => {
    // if(storeCode.length > 0){
      apiCall({
        url: apiUrls.dmsService.getRecords,
        dataToSend: {
          startDate: moment(start).startOf("d").format("YYYY-MM-DD HH:mm:ss"),
          metadataSchemaId: 13,
          endDate: moment(end || start)
            .endOf("d")
            .format("YYYY-MM-DD HH:mm:ss"),
          searchText: "",
          status: status === "ALL_REQUEST" ? null : status,
        },
        method: "post",
        processData: true,
        accessor: "documents",
      });
    // }
  };

  const columns = [
    {
      Header: "Head",
      accessor: "head",
    },
    {
      Header: "Date",
      accessor: "date",
      Cell: (rowData) => {
        return <div>{rowData?.date}</div>;
      },
    },
    {
      Header: "Request For",
      accessor: "request_for",
      Cell: (rowData) => {
        const value = rowData;
        if (!value) {
          return "-";
        }
        return (
          <div className="py-4">
            <div className="font-size-small">{value?.head}</div>
            {/* <div className="text-[1.4rem] text-[var(--ultraLightGray)]">
              {value?.sub_head}
            </div> */}
          </div>
        );
      },
    },
    {
      Header: "Description",
      accessor: "description",
      Cell: (rowData) => {
        const value = rowData?.description;
        return value || "-";
      },
    },
    {
      Header: "Qty",
      accessor: "qty",
      Cell: (rowData) => {
        const value = rowData?.quantity;
        return value ? Number(value).toFixed(2) : "-";
      },
    },
    {
      Header: "Rate (₹)",
      accessor: "rate",
      Cell: (rowData) => {
        const value = rowData?.rate;
        return value ? Number(value).toFixed(2) : "-";
      },
    },
    {
      Header: "Total Amount (₹)",
      accessor: "amount",
      Cell: (rowData) => {
        const value = rowData?.amount;
        let amount;
        if(typeof value == "string"){
          amount = Number(value).toFixed(2);
        } else {
          amount = value
        }
        return amount ? Number(amount).toFixed(2) : "-";
      },
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: (rowData) => {
        const value = rowData?.L1?.status;;
        if (!value) {
          return "-";
        }
        return (
          <div
          className={
            value === "Approved"
            ? "text-[var(--successGreen)]"
            : value === "Rejected"
            ? "text-[var(--textRed)]"
            : value === "Pending" ? "text-[var(--pendingYellow)]" : value === "Partially Approved" ? "text-[var(--successGreen)]" :  "text-[var(--pendingYellow)]"
          }
          >
            {value}
          </div>
        );
      },
    },
  ];

  let reportData = [
    {
      sheet: "Reports",
      columns: [
        { label: "Date", value: (row) => row.date }, // Top level data
        { label: "Request For", value: (row) => row.head }, // Top level data
        // { label: "Sub Head", value: (row) => row.sub_head }, // Top level data
        { label: "Description", value: (row) => row.description }, // Top level data
        { label: "Rate", value: (row) => row.rate }, // Top level data
        { label: "Quantity", value: (row) => row.quantity }, // Top level data
        { label: "Total Amount", value: (row) => row.amount }, // Top level data
        { label: "Approval Status", value: (row) => row.approval_status }, // Top level data
      ],
      content: data,
    },
  ];

  let reportSettings = {
    fileName: selectedRadio?.key == undefined ? "Report" : selectedRadio?.key+" Reports", // Name of the resulting spreadsheet
    extraLength: 3, // A bigger number means that columns will be wider
    writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
    writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
    RTL: false, // Display the columns from right-to-left (the default value is false)
  };

  const downloadRequestReports = () => {
    downloadReports(reportData, reportSettings);
  };

  return (
    <div className="dashboard-container">
      <ToolbarHeader
        title="View Request"
        showBack={false}
        containerClassName="mt-14"
        textClassCss={isMobileSmall ? "text-[2.5rem]" : "text-[3rem]"}
        renderRight={() => {
          return (
            <CustomButton
              title="Raise a Request"
              wrapperClassName="!px-10"
              textClassName={isMobileSmall ? "text-[1.4rem]" : "text-[1.5rem]"}
              onClick={() => {
                navigate("/raisearequest");
              }}
            />
          );
        }}
      />

      <div className="flex flex-col gap-y-4 mb-2 mt-4">
        <SelectInput
          valueField="value"
          labelField="key"
          onChangeFullRes={true}
          options={[
            { key: "All Request", value: "ALL_REQUEST" },
            { key: "Pending Request", value: "PENDING" },
            { key: "Approved Request", value: "APPROVED" },
          ]}
          onChange={(val) => {
            let data = val[0];
            if (data.value === "ALL_REQUEST") {
              onChangeRadio(data, null);
            } else if (data.value === "PENDING") {
              onChangeRadio(data, "PENDING");
            } else {
              onChangeRadio(data, "APPROVED");
            }
          }}
        />
        <DatePicker
          startDate={startDate}
          endDate={endDate}
          onChange={onChangeDate}
          dateRange
        />
      </div>

      <div className="overflow-auto" style={{ height: "500px" }}>
        <DetailsCard
          showGlobalSearch
          rows={columns}
          data={data}
          customRow={(row, rowData) => {
            if (row.Header === "Head") {
              return (
                <div
                  className={`min-h-[5rem] bg-[var(--darkGray2)] flex items-center justify-between px-5 text-[var(--whiteColor)] rounded-tl-[1rem] rounded-tr-[1rem]`}
                >
                  <div className="min-w-[18rem] font-size-medium">
                    {rowData?.[row?.accessor]}
                  </div>

                  {/* <FaChevronRight color="var(--whiteColor)" size={15} /> */}
                </div>
              );
            }
          }}
        />
      </div>
      {data?.length > 0 && <div className={`mt-4 flex items-center justify-end`}>
        <CustomButton
          onClick={downloadRequestReports}
          title="Download"
          wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent self-end !text-[var(--blackColor)] !px-8"
        />
      </div>}
    </div>
  );
};

export default AdminRequests;
